var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{staticClass:"flex items-center no-underline py-4",class:_vm.activeClass,attrs:{"to":_vm.path,"title":_vm.text}},[_c('i',{staticClass:"material-icons micon"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }